import { handleSelectDataSource, handleSelectRequestConfig, setAdvancedConfigToProps, } from '@/common/util/util';
import { CnCascaderSelect, componentMap as formComponentMap, formilyReact, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { handleRequestParams } from '@/common/util/request';
import isPlainObject from 'lodash/isPlainObject';
import { useRef } from 'react';
import { formComponentRefStorage } from '@/common/util/const';
import { componentRefSplit } from '@/common/util/expr-const';
const { useField } = formilyReact;
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'CascaderSelect',
    component: CnCascaderSelect,
    formComponent: (props) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const realRef = useRef(null);
        const { _dataSourceName } = props || {};
        const params = props?.requestConfig?.params;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const field = useField?.();
        if (Array.isArray(params) && params?.length > 0) {
            let _params = {};
            const { getRequestParams } = props;
            if (typeof getRequestParams === 'function') {
                _params = getRequestParams();
            }
            if (typeof field?.index === 'number') {
                const temp = field.query('..').value();
                const currentRow = temp?.[field.index];
                if (isPlainObject(currentRow)) {
                    _params.tableCurrentRow = currentRow;
                }
            }
            const realParams = handleRequestParams(params, { ..._params });
            if (realParams) {
                if (props?.requestConfig?.method === 'post') {
                    props.requestConfig.data = realParams;
                    delete props.requestConfig.params;
                }
                else {
                    props.requestConfig.params = realParams;
                }
            }
            else {
                delete props.requestConfig.params;
            }
        }
        const extraProps = {
            getRequestParams: undefined,
        };
        const fieldEntire = field?.path?.entire;
        if (_dataSourceName && fieldEntire && realRef) {
            formComponentRefStorage[`${_dataSourceName}${componentRefSplit}${fieldEntire}`] = realRef;
        }
        return (<formComponentMap.CnCascaderSelect {...props} {...extraProps} ref={realRef}/>);
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state, formProps } = config;
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
            ignoreHandleParam: true,
        });
        if (formItem?.['x-component-props']) {
            formItem['x-component-props'].getRequestParams = () => {
                return {
                    urlParamsDataSource: urlParams,
                    recordDataSource: formValue,
                    state,
                };
            };
            formItem['x-component-props']._dataSourceName =
                formProps?._dataSourceName;
        }
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
        });
        setAdvancedConfigToProps(formItem?.['x-component-props']);
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        handleSelectRequestConfig(config);
        handleSelectDataSource(config);
    },
};
